class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    setTimeout(() => {
      if (window.startFomoTimer) window.startFomoTimer();
    }, 50);
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();

      if (parsedState.item_count > 0) {
        if (window.resetFomoTimer) window.resetFomoTimer();
      } else {
        if (window.clearFomoTimer) window.clearFomoTimer();
        if (window.startFomoTimer) window.startFomoTimer();
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* FOMO TIMER */

window.FOMO_STORAGE_KEY = 'rise_fomo_timer_expiry';
window.fomoInterval = null;

window.getFomoWrap = function () {
  return document.querySelector('[data-fomo-wrap]');
};

window.getFomoTimerEl = function () {
  return document.querySelector('[data-fomo-timer]');
};

window.setFomoExpiry = function (minutes) {
  const expiry = Date.now() + minutes * 60 * 1000;
  localStorage.setItem(window.FOMO_STORAGE_KEY, String(expiry));
  return expiry;
};

window.getFomoExpiry = function () {
  const value = localStorage.getItem(window.FOMO_STORAGE_KEY);
  return value ? parseInt(value, 10) : null;
};

window.clearFomoTimer = function () {
  localStorage.removeItem(window.FOMO_STORAGE_KEY);
  if (window.fomoInterval) {
    clearInterval(window.fomoInterval);
    window.fomoInterval = null;
  }
};

window.formatFomoTime = function (ms) {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

window.updateFomoDisplay = function () {
  const wrap = window.getFomoWrap();
  const timerEl = window.getFomoTimerEl();

  if (!wrap || !timerEl) return;

  const expiry = window.getFomoExpiry();

  if (!expiry) {
    wrap.style.display = 'none';
    return;
  }

  const remaining = expiry - Date.now();

  if (remaining <= 0) {
    timerEl.textContent = '00:00';
    wrap.style.display = 'none';
    window.clearFomoTimer();
    return;
  }

  timerEl.textContent = window.formatFomoTime(remaining);
  wrap.style.display = 'block';
};

window.startFomoTimer = function () {
  const wrap = window.getFomoWrap();
  const timerEl = window.getFomoTimerEl();

  if (!wrap || !timerEl) return;

  if (window.fomoInterval) {
    clearInterval(window.fomoInterval);
    window.fomoInterval = null;
  }

  window.updateFomoDisplay();
  window.fomoInterval = setInterval(window.updateFomoDisplay, 1000);
};

window.resetFomoTimer = function () {
  const wrap = window.getFomoWrap();
  if (!wrap) return;

  const minutes = parseInt(wrap.dataset.duration || '10', 10);
  window.setFomoExpiry(minutes);
  window.startFomoTimer();
};

document.addEventListener('DOMContentLoaded', () => {
  if (window.startFomoTimer) window.startFomoTimer();
});

document.addEventListener('click', (e) => {
  if (e.target.closest('#cart-icon-bubble')) {
    setTimeout(() => {
      if (window.startFomoTimer) window.startFomoTimer();
    }, 200);
  }

  if (
    e.target.closest('button[name="add"]') ||
    e.target.closest('[data-add-to-cart]')
  ) {
    setTimeout(() => {
      if (window.resetFomoTimer) window.resetFomoTimer();
    }, 800);
  }
});